// @ts-nocheck

import React from "react";
import { FormElement } from "./../internal/JobApplicationBuilder/types";
import { v4 as uuidv4 } from "uuid";

interface ToolboxProps {
  onAddElement: (element: FormElement) => void;
}

const Toolbox2: React.FC<ToolboxProps> = ({ onAddElement }) => {
  const allOtherElements: FormElement[] = [
    {
      id: uuidv4(),
      type: "input",
      label: "Input",
      headerText: "Sample Input",
      Description: "Enter your description here ..",
      icon: "I",
      placeholder: "Enter your details",
    },
    {
      id: uuidv4(),
      type: "number",
      label: "Number",
      headerText: "Sample Number",
      icon: "N",
      placeholder: "Enter a number",
    },
    {
      id: uuidv4(),
      type: "dropdown",
      label: "Dropdown Single",
      headerText: "Sample Single Dropdown",
      Description: "Enter your description here ..",
      icon: "D",
      options: [
        { id: uuidv4(), label: "Strongly disagree", selected: false },
        { id: uuidv4(), label: "Disagree", selected: false },
        { id: uuidv4(), label: "Neither agree nor disagree", selected: false },
        { id: uuidv4(), label: "Agreement", selected: false },
        { id: uuidv4(), label: "Strongly agree", selected: false },
      ],
    },
    {
      id: uuidv4(),
      type: "multi select",
      label: "Dropdown Multi",
      headerText: "Sample Multi Dropdown",
      Description: "Enter your description here ..",
      icon: "D",
      options: [
        { id: uuidv4(), label: "Strongly disagree", selected: false },
        { id: uuidv4(), label: "Disagree", selected: false },
        { id: uuidv4(), label: "Neither agree nor disagree", selected: false },
        { id: uuidv4(), label: "Agreement", selected: false },
        { id: uuidv4(), label: "Strongly agree", selected: false },
      ],
    },
  ];

  return (
    <div className="p-0 w-full bg-transparent">
      <div>
        <h3 className=" text-wedges-gray text-[13px] font-medium mb-2  pt-3">
          Input
        </h3>
        <ul>
          {allOtherElements.map((element) => (
            <li
              key={element.id}
              onClick={() => onAddElement(element)}
              className="flex items-center py-[6px] px-3 mb-2 cursor-pointer border border-solid border-gray-300 rounded hover:bg-gray-200"
            >
              <span className="mr-2 text-dark-black-200 text-[13px] font-normal">
                {element.icon}
              </span>
              <span className="text-dark-black-200 text-[13px] font-normal">
                {element.label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Toolbox2;
